var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 21,
    viewBox: "0 0 52 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0945 1.99934C24.1553 13.0487 34.0958 20.3985 49.9971 20.9648C51.101 21.0041 52.0007 20.1019 51.999 18.9973C51.9697 0.384346 51.0957 0.00743293 25.0153 0.000138955C23.9107 -0.000170047 22.9889 0.899828 23.0945 1.99934Z",
    className: "Mouth"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9055 1.99934C27.8447 13.0487 17.9042 20.3985 2.00292 20.9648C0.899049 21.0041 -0.000722584 20.1019 0.00101553 18.9973C0.0303044 0.384346 0.904303 0.00743293 26.9847 0.000138955C28.0893 -0.000170047 29.0111 0.899828 28.9055 1.99934Z",
    className: "Mouth"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthH);
export default __webpack_public_path__ + "static/media/Mouth H.abde1dda7d85dc219f1f66c2ff55de14.svg";
export { ForwardRef as ReactComponent };